import { useTranslation } from 'react-i18next';
import { Streamdown } from 'streamdown';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { allowedTags, components } from '../ChatMessage/MessageRenderer/MessageRenderer.config';
import { ComplianceCheck, ComplianceCheckResultType } from '../ComplianceCheck/ComplianceCheck';
import { ComplianceCheckList } from '../ComplianceCheckList/ComplianceCheckList';
import { I18nNamespace } from '@/legacy/common/types';

import { DevelopmentTool, ToolResultComponent } from '.';

export const ComplianceCheckWorkflow: ToolResultComponent<
  DevelopmentTool.workflowRequesterCompliance,
  undefined,
  | Record<string, { title: string; result: ComplianceCheckResultType; details?: string; data?: string[] }>
  | { code: string; message: string }
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t('call')} />;
    case 'output-available':
      if (tool.output.code === 'TOOL_EXECUTION_FAILED') {
        return <ChatToolErrorIndicator message={t('error')} />;
      }
      return (
        <ChatToolResultIndicator message={t('result')} defaultOpen={true} disabled={false}>
          <ComplianceCheckList>
            {Object.entries(tool.output).map(([checkName, checkResult]) => (
              <ComplianceCheck
                key={checkName}
                title={checkResult.title}
                result={checkResult.result}
                additionalFiles={checkResult.data}
              >
                <Streamdown mode="static" components={components} allowedTags={allowedTags}>
                  {checkResult.details}
                </Streamdown>
              </ComplianceCheck>
            ))}
          </ComplianceCheckList>
        </ChatToolResultIndicator>
      );
  }
};
